import { render, staticRenderFns } from "./creative-specification.vue?vue&type=template&id=26ddf69a&scoped=true"
import script from "./creative-specification.vue?vue&type=script&lang=js"
export * from "./creative-specification.vue?vue&type=script&lang=js"
import style0 from "./creative-specification.vue?vue&type=style&index=0&id=26ddf69a&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26ddf69a",
  null
  
)

export default component.exports